(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    


if (!customElements.get('fluwel-page-size')) {
  customElements.define('fluwel-page-size', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const select = this.querySelector('select');
      if (!select) return;
      this.initialized = true;
      this.hidden = false;
      select.addEventListener('change', async (event) => {
        event.stopPropagation();
        if (this.saving) return;
        this.saving = true;
        select.disabled = true;
        this.setAttribute('aria-busy', 'true');
        const error = this.querySelector('[role="alert"]');
        error.hidden = true;
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ attributes: { 'Collection products per page': select.value } })
          });
          if (!response.ok) throw new Error('Could not save page size');
          const cart = await response.json();
          if (String(cart.attributes?.['Collection products per page']) !== select.value) {
            throw new Error('Page size was not saved');
          }
          const url = new URL(window.location.href);
          for (const key of Array.from(url.searchParams.keys())) {
            if (key === 'page' || key.startsWith('page_') || key === 'section_id' || key === 'sections') {
              url.searchParams.delete(key);
            }
          }
          window.location.assign(url.href);
        } catch (exception) {
          select.value = select.dataset.current;
          error.textContent = this.dataset.error;
          error.hidden = false;
          select.disabled = false;
          this.removeAttribute('aria-busy');
          this.saving = false;
        }
      });
    }
  });
}



  } catch(e) { console.error(e); }
})();
})();
